export default import.meta.ROLLDOWN_FILE_URL_Y73cl9MdOyIk4yncO3OBiw